var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading && _vm.shouldShowLoading)?_c('div',{staticClass:"app-loading"},[_c('div',{staticClass:"text-center"},[_c('Preloader')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }